var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgLogoutIcon = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 13.333L17.5 9.99967M17.5 9.99967L14.1667 6.66634M17.5 9.99967H5.83333M10.8333 13.333V14.1663C10.8333 14.8294 10.5699 15.4653 10.1011 15.9341C9.63226 16.4029 8.99637 16.6663 8.33333 16.6663H5C4.33696 16.6663 3.70107 16.4029 3.23223 15.9341C2.76339 15.4653 2.5 14.8294 2.5 14.1663V5.83301C2.5 5.16997 2.76339 4.53408 3.23223 4.06524C3.70107 3.5964 4.33696 3.33301 5 3.33301H8.33333C8.99637 3.33301 9.63226 3.5964 10.1011 4.06524C10.5699 4.53408 10.8333 5.16997 10.8333 5.83301V6.66634",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLogoutIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/logout-icon.2a1bdace.svg";
export { ForwardRef as ReactComponent };